// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "./controllers"

if (document.querySelector('meta[name="posthog-api-key"]')) {
  import("./analytics/posthog").then(({ initPostHog }) => initPostHog())
}

